import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
function DateWidget(props) {
  var _onChange = props.onChange,
    BaseInput = props.registry.widgets.BaseInput;
  return React.createElement(BaseInput, _extends({
    type: "date"
  }, props, {
    onChange: function onChange(value) {
      return _onChange(value || undefined);
    }
  }));
}
if (process.env.NODE_ENV !== "production") {}
export default DateWidget;